import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgSignInImage',
})
export default class CmgSignInImage extends Vue {

  get userIsGuacMode(): boolean {
    return this.$appStore.getters.isCustomerGuacMode;
  }

  get signInImageUrl(): string {
    const icons = this.$appStore.state.cms.images.icons;
    const customer = this.$appStore.state.customer.profile;
    if (!this.$services.loyalty.isEnrolledInLoyalty(customer)) {
      return icons.userOutline.default;
    }
    const isGuacMode = this.userIsGuacMode;
    if (isGuacMode) {
      return icons.userOutlineHaloGuacMode.default;
    }

    //non-GuacMode members
    return icons.userOutlineHalo.default;
  }
}
